import React, { createContext, PropsWithChildren, FC, useCallback, useState } from 'react';
import { ModalDefault } from 'new/routes/ModalDefault';
import { ModalConfig } from 'new/routes/RouterManager';

export const ModalsContext = createContext({
  closeModal: (key: string) => {},
  openModal: (key: string, props?: any) => {},
});

type ModalItem = {
  key: string;
  Component: React.FC & { modalConfig: ModalConfig };
  props: any;
};

export const ModalsProvider: FC<PropsWithChildren<any>> = ({
  children,
}: PropsWithChildren<any>) => {
  const modalsComponents = React.Children.toArray(children).filter(
    // @ts-ignore
    (child: React.ReactElement) => !!child.type.modalConfig,
  ) as React.ReactElement[];

  const nonModalsComponents = React.Children.toArray(
    children as React.ReactElement[],
    // @ts-ignore
  ).filter((child: React.ReactElement) => !!child.type.screenConfig);

  const modals = modalsComponents.reduce(
    // @ts-ignore
    (ms, _modal) => ({ ...ms, [_modal.type.modalConfig.name]: _modal.type }),
    {},
  );

  const [openedModals, setModal] = useState<ModalItem[]>([]);

  const openModal = useCallback((key, props) => {
    const Component = modals[key];
    if (Component) {
      setModal((state) => [
        ...state,
        {
          key,
          Component,
          props,
        },
      ]);
    } else {
      console.error(`ModalComponent[${key}]: Not Found`);
    }
  }, []);

  const closeModal = useCallback((key?: string) => {
    if (key === undefined) {
      setModal([]);
    } else {
      setModal((state) => state.filter((item) => item.key !== key));
    }
  }, []);

  return (
    <ModalsContext.Provider value={{ openModal, closeModal }}>
      {nonModalsComponents}
      {openedModals.map((item) => (
        <ModalDefault key={item.key} {...item.Component.modalConfig}>
          <item.Component {...item.props} />
        </ModalDefault>
      ))}
    </ModalsContext.Provider>
  );
};
